import { ShipmentEvent } from "../shared/interfaces";

/**
 * sorts shipment events in descending order acc to event time
 * @param shipmentEventA
 * @param shipmentEventB
 */
export const eventTimeSorter = (shipmentEventA : ShipmentEvent, shipmentEventB : ShipmentEvent) => {
    return (shipmentEventB.eventTime) - (shipmentEventA.eventTime);
};